import React, { Component } from "react";
import { Link } from "react-router-dom";

// Layout
import Header1 from "../layout/header/header1";

// Images
import bannerImg from "../../images/banner/banner3.jpg";
import { withTranslation } from "react-i18next";
import ReactMarkdown from "react-markdown";


class About1 extends Component {
	componentDidMount() {

	}

	componentWillMount() {
		const { t } = this.props;
		document.getElementById('title').innerText = t("About_Us_Title");
	}

	componentWillUnmount() {
		const { t } = this.props;
		document.getElementById('title').innerText = t("Home_Title");
	}

	render() {
		const { t } = this.props;
		return (
			<>
				<Header1 />

				<div className="page-content">
					<div
						className="page-banner ovbl-dark"
						style={{ backgroundImage: "url(" + bannerImg + ")" }}
					>
						<div className="container">
							<div className="page-banner-entry">
								<h1 className="text-white">{t("About_Us_Title")}</h1>
							</div>
						</div>
					</div>
					<div className="breadcrumb-row">
						<div className="container">
							<ul className="list-inline">
								<li>
									<Link to="/">{t("About_Us_LinkHome")}</Link>
								</li>
								<li>{t("About_Us_LinkCourses")}</li>
							</ul>
						</div>
					</div>
					<div className="content-block">
						<div className="section-area section-sp1">
							<div className="container">
								<div className="row d-flex flex-row-reverse">
									<div className="col-xl-9 col-lg-8 col-md-12 col-sm-12">
										<div className="courses-post">
											<ReactMarkdown>{t("About_Us_Content")}</ReactMarkdown>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</>
		);
	}
}

export default About1 = withTranslation()(About1);
